<template>
	<div class="store_activity">
		<van-nav-bar :title="title" fixed border>
			<template #left>
				<img src="../../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
			<template #right>
				<van-icon name="add-o" @click="showActivitiesAdd" />
			</template>
		</van-nav-bar>

    <div class="collapse">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
			<van-list
			v-model="loading"
			:finished="finished"
			:finished-text="items.length==0?'暂未设置活动':''"
			>
				<div class="col-item" v-for="(item, index) in items" :key="index">
					<div class="msg">
						<div class="topic">
							<van-icon name="point-gift-o" size="20px" />
							<span class="title">{{item.title}}</span>
						</div>
						<span class="time">
							<van-icon name="delete" @click="activitiesDel(item.id)" size="20px" class="color_red" />
						</span>
					</div>
					<van-cell-group>
						<van-cell title="活动类型" :value="activityTypesObj[item.types].name" :label="item.types!=1?'':'全场参与无需指定产品'">
						</van-cell>
						<van-cell :value="item.min" type="number" :title="activityTypesObj[item.types]['min_name']" v-if="item.types==2">
							<template #right-icon>{{activityTypesObj[item.types]['min_unit']}}</template>
						</van-cell>
						<van-cell :value="item.values" type="number" :title="activityTypesObj[item.types]['values_name']">
							<template #right-icon>{{activityTypesObj[item.types]['values_unit']}}</template>
						</van-cell>
						<van-cell :value="item.discount" type="number" :title="activityTypesObj[item.types]['discount_name']">
							<template #right-icon>{{activityTypesObj[item.types]['discount_unit']}}</template>
						</van-cell>
						<van-cell :value="item.limits" type="number" :title="activityTypesObj[item.types]['limits_name']" v-if="item.types!=1">
							<template #right-icon>{{activityTypesObj[item.types]['limits_unit']}}</template>
						</van-cell>
						<van-cell title="叠加参与">
							<template #default>
								{{item.single?'是':'否'}}
							</template>
						</van-cell>
						<van-cell title="活动日期">
							<template #default>
								{{item.activity_from*1000|moment_format('Y-MM-DD HH:mm')}}
								~
								{{item.activity_to*1000|moment_format('Y-MM-DD HH:mm')}}
							</template>
						</van-cell>
						<van-cell title="添加时间" :value="item.create_time">
						</van-cell>
					</van-cell-group>
					<div style="text-align:right">
						<van-button plain hairline type="default" @click="showActivitiesEdit(item)">编辑</van-button>
						<van-button plain hairline type="default" @click="showActivitiesGoodSet(item.id)">活动产品（{{item.in_goods}}）</van-button>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
    </div>

	<van-popup v-model="showActivitiesGood" position="bottom" :style="{ 'max-height': '80%' }">
		<van-tabs v-model="activityGoodActive">
			<van-tab title="未参与"></van-tab>
			<van-tab title="已参与"></van-tab>
		</van-tabs>
		<van-tabs v-model="categoryActive">
			<van-tab title="所有上架"></van-tab>
			<van-tab :title="cate.c_name" v-for="(cate, i) in goodCategorys" :key="i"></van-tab>
		</van-tabs>

		<van-checkbox-group v-model="goodRst" ref="goodCheckboxGroup" :style="{'padding':'10px'}">
			<van-checkbox v-model="goodAll" @click="chkGoodAll">全选</van-checkbox>

			<van-pull-refresh v-model="grefreshing" @refresh="gonRefresh">
				<div class="empty" v-if="activityGoods.length==0">
				</div>
				<van-list
				v-model="gloading"
				:finished="gfinished"
				:finished-text="activityGoods.length==0?'暂无商品':''"
				>
					<van-checkbox shape="square" :name="item.g_id" v-for="(item,index) in activityGoods" :key="index" v-if="activityGoods.length">
						<van-card
						  :num="item.g_stock"
						  :origin-price="item.g_price_origin>0?item.g_price_origin:null"
						  :price="item.g_price"
						  :desc="item.g_note"
						  :title="item.g_name"
						  :thumb="attach_url+item.g_img"
						>
						</van-card>
					</van-checkbox>
				</van-list>
			</van-pull-refresh>
		</van-checkbox-group>

		<van-button type="primary" block @click="resetActivityGood(1)" v-if="activityGoods.length && activityGoodActive==0">添加</van-button>
		<van-button type="danger" block @click="resetActivityGood(2)" v-if="activityGoods.length && activityGoodActive==1">移除</van-button>

    </van-popup>

	<van-popup v-model="showActivities" position="bottom" :style="{ 'max-height': '80%' }">
		<van-cell-group :style="{'padding':'10px'}">
			<van-field v-model.trim="activityInfo.title" maxlength="30" label="活动名称">
			</van-field>
			<van-cell title="活动日期" :value="activityInfo.activityDate" @click="init2pickerDateTime">
				<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="emptyActivityDate" :style="{'margin-left':'5px'}">清空</van-button></template>
			</van-cell>
			<van-cell title="活动类型" :value="activityTypesObj[activityInfo.types].name" is-link @click="showActivityTypePicker=true" :label="activityInfo.types!=1?'':'全场参与无需指定产品'">
			</van-cell>
			<van-field v-model="activityInfo.min" type="number" :label="activityTypesObj[activityInfo.types]['min_name']" v-if="activityInfo.types==2">
				<template #right-icon>{{activityTypesObj[activityInfo.types]['min_unit']}}</template>
			</van-field>
			<van-field v-model="activityInfo.values" type="number" :label="activityTypesObj[activityInfo.types]['values_name']">
				<template #right-icon>{{activityTypesObj[activityInfo.types]['values_unit']}}</template>
			</van-field>
			<van-field v-model="activityInfo.discount" type="number" :label="activityTypesObj[activityInfo.types]['discount_name']" :placeholder="activityInfo.types!=3?'':'PS:8折填写80'">
				<template #right-icon>{{activityTypesObj[activityInfo.types]['discount_unit']}}</template>
			</van-field>
			<van-field v-model="activityInfo.limits" type="number" :label="activityTypesObj[activityInfo.types]['limits_name']" placeholder="0或空为不限">
				<template #right-icon>{{activityTypesObj[activityInfo.types]['limits_unit']}}</template>
			</van-field>
			<van-cell title="叠加参与">
				<template #default>
					<van-switch v-model="activityInfo.single" />
				</template>
			</van-cell>
			<van-button type="primary" block @click="saveActivity()" >保存</van-button>
		</van-cell-group>
	</van-popup>


	<van-calendar v-model="showActivityDate" type="range" @confirm="onConfirmActivityDate" />

	<van-popup v-model="showActivityDateTimePopup" position="bottom">
		<van-datetime-picker
			type="datetime"
			:title="activityDateTimeTitle"
			:min-date="new Date()"
			@confirm="onConfirmActivityDateTime"
			@cancel="showActivityDateTimePopup=false"
		/>
	</van-popup>

	<van-popup v-model="showActivityTypePicker" position="bottom">
		<van-picker
		  title="活动类型"
		  show-toolbar
		  v-show="showActivityTypePicker"
		  :default-index="activityInfo.types-1"
		  :columns="activityTypes"
		  @confirm="onConfirmActivityType"
		  @cancel="showActivityTypePicker=false"
		/>
	</van-popup>
  </div>
</template>

<script type="text/ecmascript-6">
import { chkImgType,goodUnit } from "@/utils/common.js";
import { List, Card, Divider, Search, Stepper ,Calendar,  Checkbox, CheckboxGroup,DatetimePicker } from "vant";

export default {
	name: "storeOrder",
	components: {
		"van-list": List,
		"van-card": Card,
		"van-divider":Divider,
		"van-search":Search,
		"van-stepper":Stepper,
		"van-calendar":Calendar,
		"van-checkbox-group":CheckboxGroup,
		"van-checkbox":Checkbox,
		"van-datetime-picker":DatetimePicker
	},
	data() {
		return {
			title: "活动管理",
			attach_url:this.Conf.serverPre,
			items: [],
			goodUnits:[],
			goodUnitObj:{},
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			filterParams:{
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token")
			},
			gfilterParams:{
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token")
			},
			cur_s_id:-1,
			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false,
			activityTypes:[],
			activityTypesObj:{
				'1':{types:1,name:'满减', values_name:'订单满',discount_name:'立减',limits_name:'最高减',values_unit:'元',discount_unit:'元'},
				'2':{types:2,name:'每满优惠', values_name:'订单每满',discount_name:'立减',limits_name:'最高优惠',values_unit:'元',discount_unit:'元',limits_unit:'元',min_name:'最低下单',min_unit:'元'},
				'3':{types:3,name:'量满折扣', values_name:'购买数量',discount_name:'立享',limits_name:'单品限量',values_unit:'起',discount_unit:'折',limits_unit:''}
			},
			showActivities:false,
			activityGoods:[],
			showActivitiesGood:false,
			activityInfo:{types:1},
			showActivityDate:false,
			activityDateSel:[],
			showActivityTypePicker:false,
			goodCategorys:[],
			activityGoodSetId:null,
			categoryActive:0,

			showActivityDateTimePopup:false,
			activityDateTimeTitle:'',
			showActivityDateTime:0,
			activityDateTimeFrom:null,
			activityDateTimeTo:null,

			gpage:0,
			gpageSize:0,
			gtotal:0,
			gloading: false,
			gfinished: false,
			grefreshing: false,
			activityGoodActive:0,
			goodRst:[],
			goodAll:false,

			showShoppingManage:false,
			shoppingManageInfo:{},
			shoppingManageStatus:'1',
			shoppingManageExpress:'1',

			activityGoodInfo:{},
			collapseActiveName:'c_0',

			payTypes:[],
			showPayTypes:false,
			payBy:'',
			showPayQRCode:false,
			payQRCode:{}
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.goodUnitObj = goodUnit;
		this.cur_s_id = this.$route.params.s_id;
		if(!this.cur_s_id){
			this.goBack();
			return false;
		}
		this.filterParams['s_id'] = this.cur_s_id;
		this.gfilterParams['s_id'] = this.cur_s_id;
		this.loadData();

		let cols = [];
		for(var k in this.activityTypesObj){
			cols.push(this.activityTypesObj[k].name);
		}
		this.activityTypes = cols;
		this.getGoodCategory();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		getGoodCategory(){
			var params = {
				u_id: this.u_id,
				token: this.token,
				s_id: this.cur_s_id
			};
			var url = this.Conf.serverUrl + "UserStore/storeGoodCategory" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				if(response.data.code == 40001){
					this.$toast.fail(response.data.msg);
				}else{
					this.goodCategorys = response.data.category;
				}
			})
			.catch(error => {});
		},
		loadData() {
			if (this.finished) {
				return false;
			}
			this.loading = true;
			setTimeout(() => {
				if (this.refreshing) {
					this.items = [];
					this.refreshing = false;
				}
				this.page = this.page+1;
				var params = this.filterParams;
				params.page = this.page;

				var url = this.Conf.serverUrl + "UserStore/activities" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.loading = false;
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
					}else{
						if (response.data.page == 1) {
							this.pageSize = response.data.pageSize;
							this.total = response.data.total;
							this.items = response.data.activities;
						}else{
							this.items = this.items.concat(response.data.activities);
						}
						if(this.page*this.pageSize >= this.total){
							this.finished = true;
						}
					}
				})
				.catch(error => {});
			}, 1000);
		},
		onRefresh(cur) {
			this.finished = false;
			this.page = cur?(this.page-1):0;
			this.loadData();
		},
		showActivitiesAdd(){
			this.activityInfo = {types:1,s_id:this.cur_s_id};
			this.showActivities = true;
		},
		showActivitiesEdit(item){
			this.activityInfo = item;
			this.activityInfo.single = item.single?true:false
			if(item.activity_from){
				this.activityInfo.activityDate = this.$options.filters['moment_format'](item.activity_from*1000,'Y-MM-DD HH:mm:00') + '~' + this.$options.filters['moment_format'](item.activity_to*1000,'Y-MM-DD HH:mm:00');
				this.activityDateSel  = [new Date(item.activity_from), new Date(item.activity_to)];
			}
			this.showActivities = true;
		},
		onConfirmActivityType(value, index){
			this.activityInfo.types = index+1;
			this.showActivityTypePicker = false
		},
		emptyActivityDate(){
			this.activityInfo.activityDate='';
			this.activityDateSel = [];
			this.$forceUpdate();
		},
		onConfirmActivityDate(date) {
			this.activityDateSel = date;
			const [start, end] = date;
			this.showActivityDate = false;
			this.activityInfo.activityDate = this.$options.filters['moment_format'](start.getTime(),'Y-MM-DD') + '~' + this.$options.filters['moment_format'](end.getTime(),'Y-MM-DD');
		},
		init2pickerDateTime(){
			this.activityDateTimeTitle = '活动开始时间';
			this.showActivityDateTimePopup = true;
			this.showActivityDateTime = 1;
		},
		onConfirmActivityDateTime(val){
			this.showActivityDateTimePopup = false;
			if(this.showActivityDateTime==2){
				this.activityDateTimeTo = val;
				this.activityInfo.activityDate += this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD HH:mm:00');
				this.showActivityDateTime=0;
			}else{
				this.activityDateTimeFrom = val;
				this.activityInfo.activityDate = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD HH:mm:00') + '~';
				setTimeout(()=>{
					this.activityDateTimeTitle = '活动结束时间';
					this.showActivityDateTimePopup = true;
					this.showActivityDateTime=2;
				},500);
			}
		},
		saveActivity(){
			if(!this.activityInfo.title){
				this.$toast.fail("活动名称非空，请填写！");
				return false
			}
			if(!this.activityInfo.values){
				this.$toast.fail(this.activityTypesObj[this.activityInfo.types]['values_name']+"值非空，请填写！");
				return false
			}
			if(!this.activityInfo.discount){
				this.$toast.fail(this.activityTypesObj[this.activityInfo.types]['discount_name']+"值非空，请填写！");
				return false
			}
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定保存当前活动信息吗？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					data: this.activityInfo
				};
				params.data.single = params.data.single?1:0;
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/activitySave" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
					this.showActivities = false;
						that.onRefresh(true);
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
			return false;
		},
		activitiesDel(a_id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定删除当前活动信息吗？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					s_id: this.cur_s_id,
					a_id: a_id
				};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/activityDelete" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.onRefresh(true);
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
		},
		showActivitiesGoodSet(a_id){
			this.activityGoodSetId = a_id;
			this.showActivitiesGood = true;
			if(this.goodRst.length){
				this.$refs.goodCheckboxGroup.toggleAll({checked: false});
			}
			this.loadActivityGoodList();
		},
		loadActivityGoodList(){
			if (this.gfinished) {
				return false;
			}
			this.gloading = true;
			setTimeout(() => {
				if (this.grefreshing) {
					this.activityGoods = [];
					this.grefreshing = false;
				}
				this.gpage = this.gpage+1;
				var params = this.gfilterParams;
				params.page = this.page;
				params.act_id = this.activityGoodSetId;
				params.act_in = this.activityGoodActive;

				var url = this.Conf.serverUrl + "UserStore/storeGoods" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					this.gloading = false;
					if(response.data.code == 40001){
						this.$toast.fail(response.data.msg);
					}else{
						if (response.data.page == 1) {
							this.gpageSize = response.data.pageSize;
							this.gtotal = response.data.total;
							this.activityGoods = response.data.goods;
						}else{
							this.activityGoods = this.activityGoods.concat(response.data.goods);
						}
						if(this.gpage*this.gpageSize >= this.total){
							this.gfinished = true;
						}
					}
				})
				.catch(error => {});
			}, 1000);
			
		},
		chkGoodAll(){
			this.goodAll = !this.goodAll;
			if(this.goodAll){
				this.$refs.goodCheckboxGroup.toggleAll({checked: true});
			}else{
				this.$refs.goodCheckboxGroup.toggleAll({checked: false});
			}
		},
		gonRefresh(cur) {
			this.gfinished = false;
			this.gpage = cur?(this.gpage-1):0;
			this.loadActivityGoodList();
		},
		resetActivityGood(t){
			let gids = [];
			for(var i in this.goodRst){
				if(this.goodRst[i]){
					gids.push(this.goodRst[i]);
				}
			}
			if(gids.length == 0){
				this.$toast.fail("请先选择产品！");
				return false
			}
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定提交保存？",
			})
			.then(() => {
				var params = {
					u_id: this.u_id,
					token: this.token,
					act_id: this.activityGoodSetId,
					act_in: this.activityGoodActive,
					g_ids:gids
				};
				let that = this;
				var url = this.Conf.serverUrl + "UserStore/activityGoodsSet" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.showActivitiesGood = false;
						that.gonRefresh();
					}
				})
				.catch(error => {});
				
			})
			.catch((error) => {});
		}
	},
	filters:{
	},
	watch:{
		categoryActive(){
			this.gfilterParams.c_id = 0;
			if(this.categoryActive>0){
				this.gfilterParams.c_id = this.goodCategorys[this.categoryActive-1].c_id;
			}
			this.gonRefresh()
		},
		activityGoodActive(){
			this.gonRefresh()
		}
	},
	beforeDestroy: function () {
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/Store/StoreActivity.vue